import * as ambassadorWixRestaurantsMenusV1ItemModifier from './restaurants-menus-v1-item-modifier-item-modifiers.http.js';
import * as ambassadorWixRestaurantsMenusV1ItemModifierTypes from './restaurants-menus-v1-item-modifier-item-modifiers.types.js';
import * as ambassadorWixRestaurantsMenusV1ItemModifierUniversalTypes from './restaurants-menus-v1-item-modifier-item-modifiers.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createModifier(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1ItemModifierUniversalTypes.CreateModifierRequest,
  ambassadorWixRestaurantsMenusV1ItemModifierTypes.CreateModifierRequest,
  ambassadorWixRestaurantsMenusV1ItemModifierUniversalTypes.CreateModifierResponse,
  ambassadorWixRestaurantsMenusV1ItemModifierTypes.CreateModifierResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemModifier.createModifier(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/modifiers',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getModifier(): __PublicMethodMetaInfo<
  'GET',
  { modifierId: string },
  ambassadorWixRestaurantsMenusV1ItemModifierUniversalTypes.GetModifierRequest,
  ambassadorWixRestaurantsMenusV1ItemModifierTypes.GetModifierRequest,
  ambassadorWixRestaurantsMenusV1ItemModifierUniversalTypes.GetModifierResponse,
  ambassadorWixRestaurantsMenusV1ItemModifierTypes.GetModifierResponse
> {
  const payload = { modifierId: ':modifierId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemModifier.getModifier(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/modifiers/{modifierId}',
    pathParams: { modifierId: 'modifierId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listModifiers(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixRestaurantsMenusV1ItemModifierUniversalTypes.ListModifiersRequest,
  ambassadorWixRestaurantsMenusV1ItemModifierTypes.ListModifiersRequest,
  ambassadorWixRestaurantsMenusV1ItemModifierUniversalTypes.ListModifiersResponse,
  ambassadorWixRestaurantsMenusV1ItemModifierTypes.ListModifiersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemModifier.listModifiers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/modifiers',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateModifier(): __PublicMethodMetaInfo<
  'PATCH',
  { modifierId: string },
  ambassadorWixRestaurantsMenusV1ItemModifierUniversalTypes.UpdateModifierRequest,
  ambassadorWixRestaurantsMenusV1ItemModifierTypes.UpdateModifierRequest,
  ambassadorWixRestaurantsMenusV1ItemModifierUniversalTypes.UpdateModifierResponse,
  ambassadorWixRestaurantsMenusV1ItemModifierTypes.UpdateModifierResponse
> {
  const payload = { modifier: { id: ':modifierId' } } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemModifier.updateModifier(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/modifiers/{modifier.id}',
    pathParams: { modifierId: 'modifierId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateModifiers(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1ItemModifierUniversalTypes.BulkCreateModifiersRequest,
  ambassadorWixRestaurantsMenusV1ItemModifierTypes.BulkCreateModifiersRequest,
  ambassadorWixRestaurantsMenusV1ItemModifierUniversalTypes.BulkCreateModifiersResponse,
  ambassadorWixRestaurantsMenusV1ItemModifierTypes.BulkCreateModifiersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemModifier.bulkCreateModifiers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/modifiers/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateModifiers(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1ItemModifierUniversalTypes.BulkUpdateModifiersRequest,
  ambassadorWixRestaurantsMenusV1ItemModifierTypes.BulkUpdateModifiersRequest,
  ambassadorWixRestaurantsMenusV1ItemModifierUniversalTypes.BulkUpdateModifiersResponse,
  ambassadorWixRestaurantsMenusV1ItemModifierTypes.BulkUpdateModifiersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemModifier.bulkUpdateModifiers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/modifiers/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteModifier(): __PublicMethodMetaInfo<
  'DELETE',
  { modifierId: string },
  ambassadorWixRestaurantsMenusV1ItemModifierUniversalTypes.DeleteModifierRequest,
  ambassadorWixRestaurantsMenusV1ItemModifierTypes.DeleteModifierRequest,
  ambassadorWixRestaurantsMenusV1ItemModifierUniversalTypes.DeleteModifierResponse,
  ambassadorWixRestaurantsMenusV1ItemModifierTypes.DeleteModifierResponse
> {
  const payload = { modifierId: ':modifierId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemModifier.deleteModifier(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/modifiers/{modifierId}',
    pathParams: { modifierId: 'modifierId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryModifiers(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1ItemModifierUniversalTypes.QueryModifiersRequest,
  ambassadorWixRestaurantsMenusV1ItemModifierTypes.QueryModifiersRequest,
  ambassadorWixRestaurantsMenusV1ItemModifierUniversalTypes.QueryModifiersResponse,
  ambassadorWixRestaurantsMenusV1ItemModifierTypes.QueryModifiersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemModifier.queryModifiers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/modifiers/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function countModifiers(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenusV1ItemModifierUniversalTypes.CountModifiersRequest,
  ambassadorWixRestaurantsMenusV1ItemModifierTypes.CountModifiersRequest,
  ambassadorWixRestaurantsMenusV1ItemModifierUniversalTypes.CountModifiersResponse,
  ambassadorWixRestaurantsMenusV1ItemModifierTypes.CountModifiersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemModifier.countModifiers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/modifiers/count',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteModifiers(): __PublicMethodMetaInfo<
  'DELETE',
  {},
  ambassadorWixRestaurantsMenusV1ItemModifierUniversalTypes.BulkDeleteModifiersRequest,
  ambassadorWixRestaurantsMenusV1ItemModifierTypes.BulkDeleteModifiersRequest,
  ambassadorWixRestaurantsMenusV1ItemModifierUniversalTypes.BulkDeleteModifiersResponse,
  ambassadorWixRestaurantsMenusV1ItemModifierTypes.BulkDeleteModifiersResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenusV1ItemModifier.bulkDeleteModifiers(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/bulk/modifiers/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Modifier as ModifierOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  ExternalReferenceInfo as ExternalReferenceInfoOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  CreateModifierRequest as CreateModifierRequestOriginal,
  CreateModifierResponse as CreateModifierResponseOriginal,
  GetModifierRequest as GetModifierRequestOriginal,
  GetModifierResponse as GetModifierResponseOriginal,
  ListModifiersRequest as ListModifiersRequestOriginal,
  CursorPaging as CursorPagingOriginal,
  ListModifiersResponse as ListModifiersResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  UpdateModifierRequest as UpdateModifierRequestOriginal,
  UpdateModifierResponse as UpdateModifierResponseOriginal,
  BulkCreateModifiersRequest as BulkCreateModifiersRequestOriginal,
  BulkCreateModifiersResponse as BulkCreateModifiersResponseOriginal,
  BulkCreateModifierResult as BulkCreateModifierResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateModifiersRequest as BulkUpdateModifiersRequestOriginal,
  MaskedModifier as MaskedModifierOriginal,
  BulkUpdateModifiersResponse as BulkUpdateModifiersResponseOriginal,
  BulkUpdateModifierResult as BulkUpdateModifierResultOriginal,
  DeleteModifierRequest as DeleteModifierRequestOriginal,
  DeleteModifierResponse as DeleteModifierResponseOriginal,
  QueryModifiersRequest as QueryModifiersRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  QueryModifiersResponse as QueryModifiersResponseOriginal,
  CountModifiersRequest as CountModifiersRequestOriginal,
  CountModifiersResponse as CountModifiersResponseOriginal,
  BulkDeleteModifiersRequest as BulkDeleteModifiersRequestOriginal,
  BulkDeleteModifiersResponse as BulkDeleteModifiersResponseOriginal,
  BulkDeleteModifiersResult as BulkDeleteModifiersResultOriginal,
  CloneModifiersRequest as CloneModifiersRequestOriginal,
  CloneModifiersResponse as CloneModifiersResponseOriginal,
  BulkUpdateBusinessLocationIdsRequest as BulkUpdateBusinessLocationIdsRequestOriginal,
  BulkUpdateBusinessLocationIdsResponse as BulkUpdateBusinessLocationIdsResponseOriginal,
  BulkUpdateBusinessLocationIdsResponseBulkItemResult as BulkUpdateBusinessLocationIdsResponseBulkItemResultOriginal,
  BulkUpdateBusinessLocationIdsPerEntityRequest as BulkUpdateBusinessLocationIdsPerEntityRequestOriginal,
  ModifierIdLocationIds as ModifierIdLocationIdsOriginal,
  BulkUpdateBusinessLocationIdsPerEntityResponse as BulkUpdateBusinessLocationIdsPerEntityResponseOriginal,
  BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResult as BulkUpdateBusinessLocationIdsPerEntityResponseBulkItemResultOriginal,
  BulkUpdateAttachedToOrphanItemRequest as BulkUpdateAttachedToOrphanItemRequestOriginal,
  ModifierIdAttachedToOrphanItem as ModifierIdAttachedToOrphanItemOriginal,
  BulkUpdateAttachedToOrphanItemResponse as BulkUpdateAttachedToOrphanItemResponseOriginal,
  BulkItemResult as BulkItemResultOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  SyncContentToMultilingualRequest as SyncContentToMultilingualRequestOriginal,
  SyncContentToMultilingualResponse as SyncContentToMultilingualResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CountModifiersApplicationErrors as CountModifiersApplicationErrorsOriginal,
} from './restaurants-menus-v1-item-modifier-item-modifiers.types.js';
